import React, { Component } from "react";
import {
  Panel,
  Modal,
  Button
}                           from "react-bootstrap";
import _                    from "lodash";
import axios                from "axios";
import FileSaver            from "file-saver";
import moment               from "moment";
import {
  ToastContainer,
  toast
}                           from "react-toastify";
import                           "react-toastify/dist/ReactToastify.css";

import { EVSCANNER }        from "actions/const";

import { IS_VALID }         from "utils";

import saveTrail            from "../../utils/saveTrail";

import CrudComponent        from "./../zynappse-crud";
import EVScannerSchema      from "./EVScannerSchema.json";
import FormContainer        from "./FormContainer";

const WEB_PATH = window.__APP_CONFIG__.webPath || 'http://localhost:3000';

class EVScanner extends Component {
  constructor (props) {
    super(props);

    this.getEVoucherRedemptionLog = this.getEVoucherRedemptionLog.bind(this);
    this.getAllEVoucherRedemptionLog = this.getAllEVoucherRedemptionLog.bind(this);
    this.exportReport = this.exportReport.bind(this);
    this.redeemEVoucher = this.redeemEVoucher.bind(this);
    this.claimEVoucher = this.claimEVoucher.bind(this);
    this.updateEVoucherVisibility = this.updateEVoucherVisibility.bind(this);
    this.loadOptions = this.loadOptions.bind(this);
    this.accessible = this.accessible.bind(this);
  }

  getEVoucherRedemptionLog (currentPage = 1, memberIds = [], cardTypes = [], startDate = "", endDate = "") {
    let {
      EVScanner,
      actions
    } = this.props;

    let {
      selectedData,
      countType,
      limit
    } = EVScanner;

    let isShowMerchantsOwnRedemptionOnly = false,
        evScannerUserConfig;
    
    let user = Parse.User.current();

    if (
      IS_VALID(user) &&
      IS_VALID(user.get("userType"))
    ) {
      if (user.get("userType") === "MERCHANT") {
        isShowMerchantsOwnRedemptionOnly = selectedData.get("isShowMerchantsOwnRedemptionOnly") || false;
      } else if (user.get("userType") === "PARTNER") {
        isShowMerchantsOwnRedemptionOnly = true;

        if (Array.isArray(user.get("evScannerUserConfig"))) {
          evScannerUserConfig = user.get("evScannerUserConfig");
        }
      }
    } 
  
    let memberIdArray = memberIds.map((item) => item.value),
        cardTypeArray = cardTypes.map((item) => item.value);

    actions.setValue(EVSCANNER, { isLoading: true });

    new Promise((resolve, reject) => {
      if (countType === "VIEWED") {
        let query = new Parse.Query("EVoucherRedemption");

        query.include([ "EVoucher.title" ]);
        query.equalTo("EVoucher", selectedData);
        query.descending("createdAt");

        query.skip((currentPage - 1) * limit);
        query.limit(limit);

        if (memberIdArray.length !== 0) {
          query.containedIn("memberId", memberIdArray);
        }

        if (cardTypeArray.length !== 0) {
          query.containedIn("cardType", cardTypeArray);
        }

        if (
          IS_VALID(startDate) &&
          moment(startDate, "MMM DD, YYYY hh:mm A", true).isValid()
        ) {
          query.greaterThanOrEqualTo("createdAt", moment(startDate, "MMM DD, YYYY hh:mm A", true).toDate());
        }

        if (
          IS_VALID(endDate) &&
          moment(endDate, "MMM DD, YYYY hh:mm A", true).isValid()
        ) {
          query.lessThanOrEqualTo("createdAt", moment(endDate, "MMM DD, YYYY hh:mm A", true).toDate());
        }

        let totalRecord = _.clone(query);
        totalRecord.skip(0);
        totalRecord.limit(-1);

        resolve(Promise.all([
          query.find(),
          totalRecord.count()
        ]));
      } else if (countType === "CLAIMED" || countType === "REDEEMED") {
        let query = new Parse.Query("EVoucherRedemptionLog");

        // query.equalTo("status", countType);
        let sortColumnName = "";

        if (countType === "CLAIMED") {
          query.exists("dateClaimed");
          sortColumnName = "dateClaimed";
        } else {
          query.exists("dateRedeemed");
          sortColumnName = "dateRedeemed";

          if (isShowMerchantsOwnRedemptionOnly) {
            if (evScannerUserConfig) {
              query.containedIn("User", evScannerUserConfig.map((id) => new Parse.User({ id })));
            } else {
              query.equalTo("User", user);
            }
          }
        }

        query.include([ "User", "promoCategory" ]);
        query.descending(sortColumnName);

        query.equalTo("EVoucher", selectedData);

        query.skip((currentPage - 1) * limit);
        query.limit(limit);

        if (memberIdArray.length !== 0) {
          query.containedIn("memberId", memberIdArray);
        }

        if (cardTypeArray.length !== 0) {
          query.containedIn("cardType", cardTypeArray);
        }

        if (
          IS_VALID(startDate) &&
          moment(startDate, "MMM DD, YYYY hh:mm A", true).isValid()
        ) {
          query.greaterThanOrEqualTo(sortColumnName, moment(startDate, "MMM DD, YYYY hh:mm A", true).toDate());
        }

        if (
          IS_VALID(endDate) &&
          moment(endDate, "MMM DD, YYYY hh:mm A", true).isValid()
        ) {
          query.lessThanOrEqualTo(sortColumnName, moment(endDate, "MMM DD, YYYY hh:mm A", true).toDate());
        }

        let totalRecord = _.clone(query);
        totalRecord.skip(0);
        totalRecord.limit(-1);

        resolve(Promise.all([
          query.find(),
          totalRecord.count()
        ]));
      }
    })
    .then(([ data, count ]) => {
      actions.setValue(
        EVSCANNER,
        {
          isLoading: false,
          tableData: data,
          totalCount: count
        }
      );
    })
    .catch((err) => {
      console.log("error: ", err);
    });
  }

  getAllEVoucherRedemptionLog (selectedData, currentPage = 1) {
    return new Promise((resolve, reject) => {
      let limit = 10;

      let query = new Parse.Query("EVoucherRedemptionLog");
  
      query
      .include([ "EVoucher", "EVoucher.pointType", "EVoucher.deductPointType" ])
      .equalTo("EVoucherRedemption", selectedData)
      .skip((currentPage - 1) * limit)
      .limit(limit)
      .descending("voucherNumber");
  
      let totalRecord = _.clone(query);
  
      totalRecord
      .skip(0)
      .limit(-1);
  
      Promise.all([
        query.find(),
        totalRecord.count()
      ])
      .then(resolve)
      .catch(reject);
    });
  }

  exportReport (memberIds = [], cardTypes = [], startDate = "", endDate = "") {
    let {
      EVScanner,
      actions
    } = this.props;

    let {
      selectedData,
      countType
    } = EVScanner;

    actions.setValue(EVSCANNER, { isExporting: true });

    let isShowMerchantsOwnRedemptionOnly = false,
        evScannerUserConfig,
        isHideFinanceData = false;

    let user = Parse.User.current();

    if (
      IS_VALID(user) &&
      IS_VALID(user.get("userType"))
    ) {
      if (user.get("userType") === "MERCHANT") {
        isShowMerchantsOwnRedemptionOnly = selectedData.get("isShowMerchantsOwnRedemptionOnly") || false;
      } else if (user.get("userType") === "PARTNER") {
        isShowMerchantsOwnRedemptionOnly = true;

        if (Array.isArray(user.get("evScannerUserConfig"))) {
          evScannerUserConfig = user.get("evScannerUserConfig");
        }

        isHideFinanceData = typeof user.get("isHideFinanceData") === "boolean" ? user.get("isHideFinanceData") : false;
      }
    }

    axios({
      method: "post",
      url: WEB_PATH + "/EVScanner/export",
      data: {
        evoucherId: selectedData.id,
        reportType: countType,
        evScannerUserId: isShowMerchantsOwnRedemptionOnly ? (evScannerUserConfig ? evScannerUserConfig : user.id) : "",
        memberIdArray: memberIds.map((item) => item.value),
        cardTypeArray: cardTypes.map((item) => item.value),
        startDate: (
          IS_VALID(startDate) &&
          moment(startDate, "MMM DD, YYYY hh:mm A", true).isValid()
          ? (
            moment(startDate, "MMM DD, YYYY hh:mm A", true).format()
          ) : (
            ""
          )
        ),
        endDate: (
          IS_VALID(endDate) &&
          moment(endDate, "MMM DD, YYYY hh:mm A", true).isValid()
          ? (
            moment(endDate, "MMM DD, YYYY hh:mm A", true).format()
          ) : (
            ""
          )
        ),
        isHideFinanceData
      },
      responseType: "arraybuffer"
    })
    .then((res) => {
      let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'});
      FileSaver.saveAs(blob, `${countType === "VIEWED" ? "ENROLLED" : countType} eVoucher Report ${moment().format("MMM-DD-YYYY")}.xlsx`);

      actions.setValue(EVSCANNER, { isExporting: false });
    })
    .catch((err) => {
      console.log("exportReport error: ", err);
      actions.setValue(EVSCANNER, { isExporting: false });
    });
  }

  redeemEVoucher (evoucherRedemptionLog, cb = () => {}) {
    let {
      EVScanner,
      actions
    } = this.props;

    let user = Parse.User.current();
  
    if (
      IS_VALID(evoucherRedemptionLog) &&
      IS_VALID(user)
    ) {
      let cloudFunctionName = "manualRedeemEVoucher";

      if (
        IS_VALID(evoucherRedemptionLog.get("version")) &&
        evoucherRedemptionLog.get("version") === 2
      ) {
        cloudFunctionName = "manualRedeemEVoucherV2";
      }

      actions.setValue(
        EVSCANNER,
        { isRedeemingEVoucher: true }
      );

      Parse.Cloud.run(
        cloudFunctionName,
        {
          evoucherRedemptionLogId: evoucherRedemptionLog.id,
          userId: user.id
        }
      )
      .then((response) => {
        actions.setValue(
          EVSCANNER,
          { isRedeemingEVoucher: false }
          );

        cb();

        saveTrail(
          "MANUAL REDEEM",
          {
            "eVoucher Title": (
              IS_VALID(evoucherRedemptionLog.get("title")) ? (
                evoucherRedemptionLog.get("title")
              ) : IS_VALID(evoucherRedemptionLog.get("EVoucher"))  && IS_VALID(evoucherRedemptionLog.get("EVoucher").get("title")) ? (
                evoucherRedemptionLog.get("EVoucher").get("title")
              ) : (
                ""
              )
            ),
            "Member ID": (
              IS_VALID(evoucherRedemptionLog.get("memberId")) ? evoucherRedemptionLog.get("memberId") : ""
            ),
            "Card Type": (
              IS_VALID(evoucherRedemptionLog.get("cardType")) ? evoucherRedemptionLog.get("cardType") : ""
            ),
            "Transaction ID": (
              IS_VALID(evoucherRedemptionLog.get("transactionId")) ? evoucherRedemptionLog.get("transactionId") : ""
            ),
            "Status": (
              IS_VALID(evoucherRedemptionLog.get("status")) ? evoucherRedemptionLog.get("status") : ""
            ),
            "Claimed Timestamp": (
              IS_VALID(evoucherRedemptionLog.get("dateClaimed")) ? moment(evoucherRedemptionLog.get("dateClaimed")).format("MM/DD/YYYY hh:mm:ss A") : ""
            ),
            "Expired Timestamp": (
              IS_VALID(evoucherRedemptionLog.get("voucherExpiration")) ? moment(evoucherRedemptionLog.get("voucherExpiration")).format("MM/DD/YYYY hh:mm:ss A") : ""
            ),
            "Budget Amount": (
              IS_VALID(evoucherRedemptionLog.get("amount")) ? (
                evoucherRedemptionLog.get("amount")
              ) : (
                ""
              )
            ),
            "Point Deduction": (
              IS_VALID(evoucherRedemptionLog.get("deductedPointAmount")) && IS_VALID(evoucherRedemptionLog.get("deductPointType")) ? (
                `${evoucherRedemptionLog.get("deductedPointAmount")} ${evoucherRedemptionLog.get("deductPointType")}`
                ) : (
                  ""
                )
            ),
            "Promo Owner Cost Center": (
              IS_VALID(evoucherRedemptionLog.get("promoOwnerCostCenter")) ? (
                evoucherRedemptionLog.get("promoOwnerCostCenter")
              ) : (
                ""
              )
            ),
            "Promo Category": (
              IS_VALID(evoucherRedemptionLog.get("promoCategory")) && IS_VALID(evoucherRedemptionLog.get("promoCategory").get("name"))? (
                evoucherRedemptionLog.get("promoCategory").get("name")
              ) : (
                ""
              )
            )
          }
        );
      })
      .catch((err) => {
        actions.setValue(
          EVSCANNER,
          { isRedeemingEVoucher: false }
        );

        cb();

        toast.error(err.message);
      });
    }
  }

  claimEVoucher (evoucherRedemptionLog, password, cb = (err) => {}) {
    let {
      actions
    } = this.props;

    let user = Parse.User.current();

    if (
      IS_VALID(evoucherRedemptionLog) &&
      IS_VALID(user)
    ) {
      let hasRequiredEarningAmount = false,
          hasPointsDeduction = false;

      let _evoucher = evoucherRedemptionLog.get("EVoucher"),
          _pointType = _evoucher.get("pointType"),
          _requiredEarningAmount = _evoucher.get("requiredEarningAmount"),
          _deductPointType = _evoucher.get("deductPointType"),
          _deductPointAmount = _evoucher.get("deductPointAmount");
      
      if (
        IS_VALID(_pointType) &&
        IS_VALID(_requiredEarningAmount) &&
        _requiredEarningAmount > 0
      ) {
        hasRequiredEarningAmount = true;
      }

      if (
        IS_VALID(_deductPointType) &&
        IS_VALID(_deductPointAmount) &&
        _deductPointAmount > 0
      ) {
        hasPointsDeduction = true;
      }

      if (
        hasPointsDeduction &&
        (!IS_VALID(password) || !IS_VALID(password.trim()))
      ) {
        return toast.error("Member PIN is required.");
      }

      let cloudFunctionName = "manualClaimEVoucher";

      if (
        IS_VALID(evoucherRedemptionLog.get("version")) &&
        evoucherRedemptionLog.get("version") == 2
      ) {
        cloudFunctionName = "manualClaimEVoucherV2";
      }

      actions.setValue(
        EVSCANNER,
        { isClaimingEVoucher: true }
      );

      Parse.Cloud.run(
        cloudFunctionName,
        {
          evoucherRedemptionId: evoucherRedemptionLog.id,
          memberId: evoucherRedemptionLog.get("memberId"),
          password: password,
          userId: user.id
        }
      )
      .then((response) => {
        let {
          evoucherRedemption
        } = response;
        
        actions.setValue(
          EVSCANNER,
          { isClaimingEVoucher: false }
        );

        cb(null);

        saveTrail(
          "MANUAL CLAIM",
          {
            objectId: evoucherRedemptionLog.id,
            "eVoucher Title": (
              IS_VALID(evoucherRedemptionLog.get("title")) ? (
                evoucherRedemptionLog.get("title")
              ) : IS_VALID(evoucherRedemptionLog.get("EVoucher"))  && IS_VALID(evoucherRedemptionLog.get("EVoucher").get("title")) ? (
                evoucherRedemptionLog.get("EVoucher").get("title")
              ) : (
                ""
              )
            ),
            "Member ID": (
              IS_VALID(evoucherRedemptionLog.get("memberId")) ? evoucherRedemptionLog.get("memberId") : ""
            ),
            "Card Type": (
              IS_VALID(evoucherRedemptionLog.get("cardType")) ? evoucherRedemptionLog.get("cardType") : ""
            ),
            "Status": (
              IS_VALID(evoucherRedemption.get("status")) ? evoucherRedemption.get("status") : ""
            ),
            "Transaction ID": (
              IS_VALID(evoucherRedemption.get("transactionId")) ? evoucherRedemption.get("transactionId") : ""
            )
          }
        );
      })
      .catch((err) => {
        cb(err);

        actions.setValue(
          EVSCANNER,
          { isClaimingEVoucher: false }
        );
      });
    }
  }

  updateEVoucherVisibility (evoucherRedemptionLog, cb = () => {}) {
    let {
      actions
    } = this.props;

    actions.setValue(
      EVSCANNER,
      { isUpdatingVisibility: true }
    );

    const isHidden = !!!evoucherRedemptionLog.get('isHidden');

    Parse.Cloud.run(
      'updateEVoucherVisibility',
      {
        evoucherRedemptionLogId: evoucherRedemptionLog.id,
        isHidden
      }
    )
    .then((res) => {
      actions.setValue(
        EVSCANNER,
        { isUpdatingVisibility: false }
      );

      cb(null);

      saveTrail(
        'CHANGE VISIBILITY',
        {
          objectId: evoucherRedemptionLog.id,
          "eVoucher Title": (
            IS_VALID(evoucherRedemptionLog.get("title")) ? (
              evoucherRedemptionLog.get("title")
            ) : IS_VALID(evoucherRedemptionLog.get("EVoucher"))  && IS_VALID(evoucherRedemptionLog.get("EVoucher").get("title")) ? (
              evoucherRedemptionLog.get("EVoucher").get("title")
            ) : (
              ""
            )
          ),
          "Member ID": (
            IS_VALID(evoucherRedemptionLog.get("memberId")) ? evoucherRedemptionLog.get("memberId") : ""
          ),
          "Card Type": (
            IS_VALID(evoucherRedemptionLog.get("cardType")) ? evoucherRedemptionLog.get("cardType") : ""
          ),
          "Status": (
            IS_VALID(evoucherRedemptionLog.get("status")) ? evoucherRedemptionLog.get("status") : ""
          ),
          "Transaction ID": (
            IS_VALID(evoucherRedemptionLog.get("transactionId")) ? evoucherRedemptionLog.get("transactionId") : ""
          ),
          "Type": isHidden ? 'Hide' : 'Unhide'
        }
      );
    })
    .catch((err) => {
      cb(err);

      actions.setValue(
        EVSCANNER,
        { isUpdatingVisibility: false }
      );
    });
  }

  loadOptions (input = "", cb, className = "MemberDetail") {
    let query = new Parse.Query(className),
        objItem;
    if (className === "MemberDetail") {
      query
      .matches("memberId", input, "i")
      .ascending("memberId")
      .exists("memberId");

      objItem = (item) => {
        return {
          label: item.get("memberId"),
          value: item.get("memberId")
        };
      };
    } else if (className === "VoucherCardType") {
      query
      .matches("name", input, "i")
      .ascending("name");

      objItem = (item) => {
        return {
          label: item.get("name"),
          value: item.get("name")
        };
      };
    }

    query.limit(10);

    query.find()
    .then((data) => {
      cb(
        null,
        {
          options: data.map(objItem)
        }
      );
    })
    .catch((err) => {
      cb(
        null,
        {
          options: []
        }
      );
    })
  }
  
  accessible (actionType) {
    let {
      access
    } = this.props.accessjson;

    if (access.length !== 0) {
			var currentPath = window.location.pathname,
					index = access.map((module) => module.route.toUpperCase()).indexOf(currentPath.toUpperCase()),
					actions = [];

			if (access[index]) {
				actions = access[index].actions
			}

			if (actions.length != 0) {
				if (actions.indexOf(actionType.toUpperCase()) === -1) {
					return 'none';
				} else {
					return '';
				}
			} else {
	      return 'none';
	    }
		} else {
			return 'none';
		}
  }

  render () {
    let {
      EVScanner,
      accessjson,
      actions
    } = this.props;

    let {
      showModal,
      isLoadingAction,
      isRedeemingEVoucher,
      formType
    } = EVScanner;

    let moduleQuery = [
      { method: "descending", column: "createdAt" },
      { method: "notEqualTo", column: "status", value: "DRAFT" }
    ];

    let schema = EVScannerSchema;

    let user = Parse.User.current();

    if (IS_VALID(user) && IS_VALID(user.get("userType"))) {
      if (user.get("userType") === "MERCHANT") {
        moduleQuery.push({ method: "containedIn", column: "evScannerUser", value: [user] });
      } else if (user.get("userType") === "VIP HOST") {
        moduleQuery.push({ method: "containedIn", column: "evScannerUser", value: [] });
      } else if (user.get("userType") === "PARTNER") {
        if (Array.isArray(user.get("evScannerUserConfig"))) {
          moduleQuery.push({ method: "containedIn", column: "evScannerUser", value: user.get("evScannerUserConfig").map((id) => new Parse.User({ id })) });
        }
      }

      if (user.get("userType") !== "ADMIN") {
        let indexOfTotalJoined = EVScannerSchema.columns.map((item) => item.columnName).indexOf("totalJoined");

        if (indexOfTotalJoined !== -1) {
          let clone = {
            ...EVScannerSchema,
            columns: [...EVScannerSchema.columns]
          }
          clone.columns.splice(indexOfTotalJoined, 1);

          schema = clone;
        }
      }
    }

    let crudProps = {
      schema: schema,
      access: accessjson.access,
      moduleQuery: moduleQuery,
      customItems: [
        {
          columnName: "title",
          render: ({value, column, getTableData, object}) => {
            let renderValue = "";

            if (IS_VALID(value)) {
              renderValue = value.substr(0, 100).trim() + (value.length <= 100 ? "" : "...");
            }

            return renderValue;
          }
        },
        {
          columnName: "totalJoined",
          render: ({ value, column, getTableData, object }) => {
            let renderValue = 0;

            if (IS_VALID(value) && value !== 0) {
              renderValue = (
                <a
                  href="javascript:void(0)"
                  onClick={() => {
                    actions.setValue(
                      EVSCANNER,
                      {
                        showModal: true,
                        selectedData: object,
                        formType: "VIEW",
                        countType: "VIEWED"
                      }
                    );
                  }}
                  >
                  {value}
                </a>
              );
            }

            return renderValue;
          }
        },
        {
          columnName: "totalClaimed",
          render: ({ value, column, getTableData, object }) => {
            let renderValue = 0;

            if (IS_VALID(value) && value !== 0) {
              renderValue = (
                <a
                  href="javascript:void(0)"
                  onClick={() => {
                    actions.setValue(
                      EVSCANNER,
                      {
                        showModal: true,
                        selectedData: object,
                        formType: "VIEW",
                        countType: "CLAIMED"
                      }
                    );
                  }}
                  >
                  {value}
                </a>
              );
            }

            return renderValue;
          }
        },
        {
          columnName: "totalRedeemed",
          render: ({ value, column, getTableData, object }) => {
            let renderValue = 0;

            if (IS_VALID(value) && value !== 0) {
              renderValue = (
                <a
                  href="javascript:void(0)"
                  onClick={() => {
                    actions.setValue(
                      EVSCANNER,
                      {
                        showModal: true,
                        selectedData: object,
                        formType: "VIEW",
                        countType: "REDEEMED"
                      }
                    );
                  }}
                  >
                  {value}
                </a>
              );
            }

            return renderValue;
          }
        },
        {
          columnName: "status",
          render: ({value, column, getTableData, object}) => {
            let renderValue = value;

            if (IS_VALID(value)) {
              switch (value.toUpperCase()) {
                case "PUBLISH":
                  renderValue = <span style={{ color: "green" }}>{value}</span>;
                  break;
                case "EXPIRED":
                  renderValue = <span style={{ color: "red" }}>{value}</span>
                  break;
                case "DRAFT":
                  renderValue = <span style={{ color: "gray" }}>{value}</span>
                  break;
              }
            }

            return renderValue;
          }
        }
      ]
    };

    let formContainerProps = {
      ...this.props,
      getEVoucherRedemptionLog: this.getEVoucherRedemptionLog,
      getAllEVoucherRedemptionLog: this.getAllEVoucherRedemptionLog,
      exportReport: this.exportReport,
      redeemEVoucher: this.redeemEVoucher,
      claimEVoucher: this.claimEVoucher,
      updateEVoucherVisibility: this.updateEVoucherVisibility,
      loadOptions: this.loadOptions,
      accessible: this.accessible
    };

    return (
      <div>
        <Panel>
          <Panel.Heading style={{
            backgroundColor: '#D1282F',
            color: 'white'
          }}>
            <h4>EVScanner</h4>
          </Panel.Heading>
          <Panel.Body>
            <CrudComponent {...crudProps}/>
          </Panel.Body>
        </Panel>
        <Modal
          bsSize={"lg"}
          backdrop={formType.toUpperCase() === "VIEW" ? "static" : null}
          show={showModal}
          onHide={() => {
            if (!isLoadingAction || !isRedeemingEVoucher) {
              actions.setValue(
                EVSCANNER,
                {
                  showModal: false
                }
              );
            }
          }}>
          <Modal.Header closeButton>
            <Modal.Title>{formType.toUpperCase()}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormContainer {...formContainerProps}/>
          </Modal.Body>
          <Modal.Footer>
            <Button
              disabled={isLoadingAction || isRedeemingEVoucher}
              onClick={() => {
                if (!isLoadingAction || !isRedeemingEVoucher) {
                  actions.setValue(
                    EVSCANNER,
                    {
                      showModal: false
                    }
                  );
                }
              }}
              >
                CLOSE
              </Button>
          </Modal.Footer>
        </Modal>
        <ToastContainer />
      </div>
    );
  }
}

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';

function mapStateToProps(state) {
	var {
		accessjson,
    EVScanner
	} = state;

	const props = {
		accessjson,
    EVScanner
	};
	return props;
}

function mapDispatchToProps(dispatch) {
  const actions = {
    setValue: generics.setValue
  };

  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EVScanner);



// WEBPACK FOOTER //
// ./components/EVScanner/index.js